<div class="recover-password">
  <div class="card">
    <h3>{{ 'Password recovery' | translate }}</h3>
    @if (
      recovery.cooldown.remaining('recoveryRedeem') ||
      recovery.cooldown.remaining('recoveryInspect')
    ) {
      <p role="status">
        {{
          'Please wait [seconds] seconds before trying again.'
            | translate
              : {
                  seconds:
                    recovery.cooldown.remaining('recoveryRedeem') ||
                    recovery.cooldown.remaining('recoveryInspect'),
                }
        }}
      </p>
    }
    @switch (status()) {
      @case ('inspecting') {
        <p class="muted">{{ 'Checking your recovery link…' | translate }}</p>
      }
      @case ('ready') {
        <p>
          {{
            'This link signs you in as the team "[role]" so you can set new team passwords.'
              | translate: { role: roleName() }
          }}
        </p>
        <p class="muted">
          {{ 'Nothing changes until you continue. The link can be used once.' | translate }}
        </p>
        <div class="actions">
          <andor-button
            type="gradient"
            [disabled]="recovery.cooldown.remaining('recoveryRedeem') > 0"
            (click)="continue()">
            {{ 'Continue as [role]' | translate: { role: roleName() } }}
          </andor-button>
          <button type="button" class="link" (click)="back()">
            {{ 'Back to login' | translate }}
          </button>
        </div>
      }
      @case ('consuming') {
        <p class="muted">{{ 'Signing in…' | translate }}</p>
      }
      @case ('invalid') {
        <andor-notice variant="error">
          {{ 'This recovery link is invalid, expired, or was already used.' | translate }}
        </andor-notice>
        <div class="actions">
          <andor-button (click)="back()">{{ 'Back to login' | translate }}</andor-button>
        </div>
      }
      @case ('error') {
        <andor-notice variant="error">
          {{ 'The recovery link could not be checked. Please try again.' | translate }}
        </andor-notice>
        <div class="actions">
          <andor-button
            type="gradient"
            [disabled]="recovery.cooldown.remaining('recoveryInspect') > 0"
            (click)="retry()">
            {{ 'Retry' | translate }}
          </andor-button>
          <andor-button (click)="back()">{{ 'Back to login' | translate }}</andor-button>
        </div>
      }
    }
  </div>
</div>
